@if (bulkStore.getSteps(); as currentSteps) {
  <div class="flex align-items-center gap-4">
    <div class="flex align-items-center gap-2" *ngIf="currentEntityMenuItem">
      <i [class]="currentEntityMenuItem.icon"></i>
      <strong>{{ currentEntityMenuItem.label }}</strong>
    </div>

    <i class="fas fa-chevron-right"></i>

    <div class="flex align-items-center gap-2" *ngIf="currentActionMenuItem">
      <i [class]="currentActionMenuItem.icon"></i>
      <strong>{{ currentActionMenuItem.label }}</strong>
    </div>

    @for (step of currentSteps; track $index) {
      <i class="fas fa-chevron-right"></i>

      <div
        [class]="
          bulkStore.getNumberOfCurrentStep() < $index ? 'opacity-40' : ''
        "
        class="flex align-items-center gap-2"
        *ngIf="currentActionMenuItem">
        @if (bulkStore.getNumberOfCurrentStep() > $index) {
          <i class="fas fa-check-circle"></i>
        } @else {
          <i class="fa-regular fa-circle"></i>
        }
        <strong>
          {{ bulkStore.getStepLabel(step) }}
        </strong>
      </div>
    }
  </div>
}
